const nodeArrayToPath = node => {
  let path = 'node'

  if (node.paths.length) {
    let nodes = node.paths
    path += '.nodes.' + nodes.join('.nodes.')
  }
  path += '.nodes.' + node.id

  return path
}

export default nodeArrayToPath



// WEBPACK FOOTER //
// ./src/utils/buildNodePath.js